import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumn.html?raw';
import on from 'dojo/on';
import query from 'dojo/query';
import dojoDate from 'dojo/date';
import locale from 'dojo/date/locale';
import DayRow from '../DayRow/DayRow';
import "../DayRow/DayRow";
import MonthAndYearlyCalendar from 'dojox/widget/MonthAndYearlyCalendar';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "dojox/widget/MonthAndYearlyCalendar";
/**
 * Interface f�r das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */

import MonthColumnPlanMonthPicker from '../MonthColumnPlanMonthPicker/MonthColumnPlanMonthPicker';
import "../MonthColumnPlanMonthPicker/MonthColumnPlanMonthPicker";

interface _groupRegistryObj {
	group: MCP_group,
	days?: MdsLax<InstanceType<typeof DayRow>>[],
	color?: string,
	proiority?: number,
	concurrentGroups?: number
	appointments?: Array<{ appointment: MCP_appointment, day: MdsLax<InstanceType<typeof DayRow>> }>
}
class MonthColumn extends compose(_WidgetBaseSP) {
	templateString: any = template;

	_fetchGroupDataRequest: any = null;
	_fetchBookingsRequest: any = null;
	_fetchDraftDataRequest: any = null;
	_fetchGroupDataTimeout: any = null;
	_fetchBookingsTimeout: any = null;
	_fetchDraftDataTimeout: any = null;

	monthColumn: HTMLElement;
	headerRow: HTMLElement;
	dayRowsContainer: HTMLElement;
	MonthNameDisplay: HTMLElement;

	monthSelectionDialog: HTMLElement;
	monthSelectorButton_Ok: HTMLButtonElement;
	monthSelector: MdsLax<InstanceType<typeof MonthAndYearlyCalendar>>;

	year: number = -1;
	month: number = -1;
	monthDate: Date = null;
	includeYearInTitle: boolean = false;
	editable: boolean = false;
	print: boolean = false;

	_dayRegistry: Array<MdsLax<InstanceType<typeof DayRow>>> = [];
	daysWorkload: Array<{ day: MdsLax<InstanceType<typeof DayRow>>, concurrentGroups: Array<MCP_group> }> = [];
	_groupRegistry: Array<_groupRegistryObj> = [];
	_appointmentRegistry: Array<{ appointment: MCP_appointment, day: MdsLax<InstanceType<typeof DayRow>> }> = [];
	_staticData: Array<MCP_booking> = null;

	groupDivWidth: number = 20;// group div width in px, gebraucht um groupNode width einzustellen und in this._displayGroups();
	displayedConcurrentGroups_limit: number = 8; // default war einmal vor nicht all zu langer zeit 5. jetzt owa nimma

	_displayGroupTimeout: any = null;

	monthPickerForDlg: MdsLax<InstanceType<typeof MonthColumnPlanMonthPicker>>;

	menuOptionsBar:HTMLDivElement;

	// Methods ----------------------------------------------------
	
	public getCurrentYear(){
		return this.year;
	}
	public getCurrentMonth(){
		return this.month;
	}

	public requestStaticBookingColorChange(coloringName: string) {
		for (let dr of this._dayRegistry){
			dr.requestStaticBookingColorChange(coloringName);
		}
	}

	public _onclickMonthHeaderUp(): void {
		this.emit("MonthColumn/header/monthUp", this);
	}

	public _onclickMonthHeaderDown(): void {
		this.emit("MonthColumn/header/monthDown", this);
	}

	_setMonthSelectionDate(): void {

		(this.monthSelector as any)._children[0]._cachedDate = this.monthDate;
		(this.monthSelector as any)._children[0]._updateSelectedMonth();
		(this.monthSelector as any)._children[0]._updateSelectedYear();
	}

	// month header -------------start
	_onclickMonthHeaderCalendar(): void {
		//this._setMonthDate(selectedDate.getFullYear(), selectedDate.getMonth());
		
		if ((this.monthPickerForDlg != null) || (typeof this.monthPickerForDlg != 'undefined')) {
			try {
				this.monthPickerForDlg.destroyRecursive();
			} catch { }
		}
		this.monthPickerForDlg = new MonthColumnPlanMonthPicker(this.monthDate);
		this.monthPickerForDlg.setSingleSelect(true);
		this.monthPickerForDlg.setSelectedDate(this.year, this.month);

		let dlg = new GenericDialog();
		dlg.destroyOnClose = true;
		dlg.setSize('smaller');
		dlg.show(this.monthPickerForDlg, this.translations["MonthColumnPlan__Label_ChangeMonth"], "", null, 'okcancel', lang.hitch(this, (res: any) => {
			if (res == 1) { //1=ok button
				for (let val of this.monthPickerForDlg.getSelectedValues()){
					//setzt den neuen monat
					this._setMonthDate(val.y, val.m);
				}
				this.emit("refreshStaticValues");
			}
		}));
	}

	_onKeyUp_monthSelectionDialog(evt: KeyboardEvent): void {
		if (evt.key == "ArrowUp") {
			this._onClick_monthSelectorButton_Ok();
		}
	}

	_onclickPrintButton(){
		if (this.domNode.classList.contains("printMe") == false){
			this.domNode.classList.add("printMe");
		}
		this.emit("triggerPrint");
	}

	_onClick_monthSelectorButton_Ok(): void {
		(this.monthSelector as any)._children[0].onValueSelected((this.monthSelector as any)._children[0]._cachedDate);
		let selectedDate: Date = this.monthSelector.get("value");

		this._setMonthDate(selectedDate.getFullYear(), selectedDate.getMonth());

		this.UiModder.domClass.add(this.monthSelectionDialog, "w3-hide");
	}

	setupMonthSelectionDialog(): void {

		// alle actionbuttons der MonthAndYearCalendars ausblenden (sind h�sslich)
		let MYBtns = query(".dojoxCal-MY-btns", this.monthSelector.domNode);
		let yearLabels = query(".dojoxCalendarYearLabel", this.monthSelector.domNode);
		let monthLabels = query(".dojoxCalendarMonthLabel", this.monthSelector.domNode);

		for (let i = 0; i < MYBtns.length; i++) {
			this.UiModder.domAttr.set(<HTMLElement>MYBtns[i], "display", "none");
		}
		for (let j = 0; j < yearLabels.length; j++) {
			this.UiModder.domAttr.set(<HTMLElement>yearLabels[j], "height", "25px");
		}
		for (let k = 0; k < monthLabels.length; k++) {
			this.UiModder.domAttr.set(<HTMLElement>monthLabels[k], "height", "25px");
		}

	}

	_onclickMonthHeaderClose(): void {
		this.emit("MonthColumn/header/monthClose", this);
	}

	// month header -------------end

	// display groups (DOM)-----------------------------------------------------START
	_displayGroups(): void { //ggf ein Array<monthItem>

		this._clearAllRails();

		let absPos_LeftStart: number = 0; //start point for absolute positioning
		let minDivWidth: number = this.groupDivWidth;

		if (this._dayRegistry[0]._destroyed == true){
			return;//wir gehen davon aus, wenn die erste day row destroyed ist, dann sind die anderen auch destroyed. deshalb stoppen wir hier die execution...
		}
		absPos_LeftStart = this._dayRegistry[0].labelNode.getBoundingClientRect().width + 1;



		let allMonthGroups = query("div .group", this.domNode);
		for (let i = 0; i < allMonthGroups.length; i++) {
			let monthGroupNode: HTMLElement = <HTMLElement>allMonthGroups[i];
			this.UiModder.domConstruct.destroy(monthGroupNode);
		}

		let concurrentGroupsQuantity: number = 1; // fallback f�r sich �berschneidende gruppen

		for (let x = 0; x < this.daysWorkload.length; x++) {
			if (this.daysWorkload[x].concurrentGroups.length > concurrentGroupsQuantity) { concurrentGroupsQuantity = this.daysWorkload[x].concurrentGroups.length; }
		}

		let strMonthDate: string = locale.format(this.monthDate, {
			selector: "date",
			datePattern: "yyyy-MM"
		});

		if (this._groupRegistry.length) {

			// Pro Projekt einen absolut positionierten div anzeigen mit dem top - left am date_start Widget.

			for (let i = 0; i < this._groupRegistry.length; i++) {

				let groupObj: _groupRegistryObj = this._groupRegistry[i];

				let skipRender = false;
				try{
					if (groupObj.appointments.length < 1) {
						skipRender = true;
					}
				}catch{/* im zweifel doch anzeigen */}

				if (skipRender == false){
					let groupLabel: string = groupObj.group.label;
					if (groupLabel) {
						groupLabel = groupLabel.split(" ").join("_");
					}

					let displayRailsLimit: number = concurrentGroupsQuantity > this.displayedConcurrentGroups_limit ? this.displayedConcurrentGroups_limit : concurrentGroupsQuantity;

					// let's take care of prority - absolute postioning coordinates of the div relative to it's cuncurrents

					let priority: number = this.findFreeRail(groupObj, displayRailsLimit);

					if (priority == null) {
						//console.log("PRIORITY == NULL", groupObj.group);
						continue;
					}

					let startDayWidget: MdsLax<InstanceType<typeof DayRow>>;
					let divHeight: number = 0;
					let bgColor: string = "#" + groupObj.group.primaryColor;
					let txtColor: string = "#" + groupObj.group.secondaryColor;
					let tooltipText: string = groupObj.group.tooltip + " (" + groupObj.group.label + ")";
					if ((groupObj.group.tooltip == null) || (typeof groupObj.group.tooltip == 'undefined') || (groupObj.group.tooltip == "") || (groupObj.group.tooltip == "null") || (groupObj.group.tooltip == "[Object object]")){
						tooltipText = groupObj.group.label;
					}
					let daysToShow: Array<MdsLax<InstanceType<typeof DayRow>>> = []; // die Tage per Monat, die wir anzeigen m�chten. das Array bruachen wir um den StartWidget zu ermitteln


					// H�he des divs errechnen
					for (let j = 0; j < groupObj.days.length; j++) {
						if (groupObj.days[j].contentNode) {

							let strGroupMonthDate = locale.format(groupObj.days[j].date, {
								selector: "date",
								datePattern: "yyyy-MM"
							});

							if (strMonthDate == strGroupMonthDate) {
								daysToShow.push(groupObj.days[j]);
								divHeight = divHeight + groupObj.days[j].contentNode.offsetHeight;
							}
						}
					}

					startDayWidget = daysToShow[0];

					if (startDayWidget.groupNode) {

						// div positionieren
						let absPos_left: number = absPos_LeftStart + minDivWidth * priority;

						let node: HTMLElement = <HTMLElement>this.UiModder.domConstruct.toDom("<div style='z-index:2; overflow: hidden; background-color:" + bgColor + "; opacity: 0.6; color: " + txtColor + "; height:" + divHeight + "px; width:" + minDivWidth + "px; position: absolute; top:0; left:" +
							absPos_left + "px;' data-group='" + groupObj.group.ID + "' class = 'group' title = '" + tooltipText + " '></div>");

						let dndGroupLabel: string = "";
						if (groupLabel) dndGroupLabel = groupLabel.length > 16 ? groupLabel.slice(0, 16) + "..." : groupLabel;
						let dndGroupDivHeight: number = divHeight > 200 ? 200 : divHeight;  // 200 is a random number

						let dndHandle: HTMLElement = this.UiModder.domConstruct.create("div", {
							"style": {
								"background-color": bgColor,
								"color": txtColor,
								"height": "20px",
								"cursor": "move"
							},
							"className": "dndHandle",
							"data-dndHeight": dndGroupDivHeight,
							"data-dndId": groupObj.group.ID,
							"data-dndMonth": this.id,
							"data-dndType": "group",
							"draggable": true
						}, node);

						on(dndHandle, "dragstart", function (evt) { // scope: dndHandle
							this.style.height = this.dataset.dndheight + "px";
							evt.dataTransfer.setData('text/plain', JSON.stringify({ dndId: this.dataset.dndid, dndMonth: this.dataset.dndmonth, dndType: this.dataset.dndtype }));
						});
						on(dndHandle, "dragend", function (evt) { // scope: this.dndNode
							this.style.height = "20px";
						});

						let groupLabelNodeContaner: HTMLElement = this.UiModder.domConstruct.create("div", {
							style: "padding-top: " + divHeight / 2 + "px; padding-bottom: 5px; overflow:hidden",
						}, node);

						let groupLabelNode: HTMLElement = this.UiModder.domConstruct.create("div", {
							//style: "margin-top: "+divHeight / 2 + "px;",
							"className": "groupLabelText",
							innerHTML: groupLabel
						});

						on(groupLabelNode, "click", lang.hitch(this, function (evt) {
							evt.stopPropagation();
							evt.target.parentElement.click();
						}));

						on(groupLabelNodeContaner, "click", lang.hitch(this, function (evt) {
							evt.stopPropagation();
							evt.target.parentElement.click();
						}));

						this.UiModder.domConstruct.place(groupLabelNode, groupLabelNodeContaner);

						on(node, "click", lang.hitch(this, "_onclick_groupDiv"));

						this.UiModder.domConstruct.place(node, startDayWidget.groupNode);




						//updated die tooltips fuer die gruppe
						startDayWidget.updateBetterTooltipsForDndHanldes();
					} else {
						console.warn("node is not present");
					}
				} else {//skip render block

				}


			} // for loop in der groupRegistry -- end

		}
	}

	private DateStringToISOstring(input:string){
		let dateString = input;
		let [datePart, timePart] = dateString.split(' ');
		let [day, month, year] = datePart.split('.');
		let dateObject = new Date(`${year}-${month}-${day}T${timePart}`);
		return dateObject.toISOString().split('T')[0];
	}

	_displayGroupOnLastRail(groupObj: _groupRegistryObj): void {

		let absPos_LeftStart: number = 0; //start point for absolute positioning
		let minDivWidth: number = this.groupDivWidth;
		let dndGroupLabel: string = "";

		let groupLabel: string = groupObj.group.label;
		groupLabel = groupLabel ? groupLabel.split(" ").join("_") : "";

		absPos_LeftStart = this._dayRegistry[0].labelNode.getBoundingClientRect().width + 1;

		let concurrentGroupsQuantity: number = 1; // fallback f�r sich �berschneidende gruppen

		for (let x = 0; x < this.daysWorkload.length; x++) {
			if (this.daysWorkload[x].concurrentGroups.length > concurrentGroupsQuantity) {
				concurrentGroupsQuantity = this.daysWorkload[x].concurrentGroups.length;
			}
		}

		if (concurrentGroupsQuantity > this.displayedConcurrentGroups_limit) concurrentGroupsQuantity = this.displayedConcurrentGroups_limit;

		let strMonthDate: string = locale.format(this.monthDate, {
			selector: "date",
			datePattern: "yyyy-MM"
		});

		let priority: number = concurrentGroupsQuantity - 1;

		let startDayWidget: MdsLax<InstanceType<typeof DayRow>>;
		let divHeight: number = 0;
		let bgColor: string = "#" + groupObj.group.primaryColor;
		let txtColor: string = "#" + groupObj.group.secondaryColor;
		let tooltipText: string = groupObj.group.tooltip; // T'ODO: tooltip gscheit

		let daysToShow: Array<MdsLax<InstanceType<typeof DayRow>>> = []; // die Tage per Monat, die wir anzeigen m�chten. das Array bruachen wir um den StartWidget zu ermitteln


		// H�he des divs errechnen
		for (let j = 0; j < groupObj.days.length; j++) {
			if (groupObj.days[j].contentNode) {

				let strGroupMonthDate: string = locale.format(groupObj.days[j].date, {
					selector: "date",
					datePattern: "yyyy-MM"
				});

				if (strMonthDate == strGroupMonthDate) {
					daysToShow.push(groupObj.days[j]);
					divHeight = divHeight + groupObj.days[j].contentNode.offsetHeight;
				}
			}
		}

		startDayWidget = daysToShow[0];

		if (startDayWidget.groupNode) {

			// div positionieren
			let absPos_left: number = absPos_LeftStart + minDivWidth * priority;

			let node: HTMLElement = <HTMLElement>this.UiModder.domConstruct.toDom("<div style='z-index:2; overflow: hidden; background-color:" + bgColor + "; opacity: 1; color: " + txtColor + "; height:" + divHeight + "px; width:" + minDivWidth + "px; position: absolute; top:0; left:" +
				absPos_left + "px;" + "' data-group='" + groupObj.group.ID + "' class = 'group' title = '" +
				tooltipText + " '></div>");

			if (groupLabel) dndGroupLabel = groupLabel.length > 16 ? groupLabel.slice(0, 16) + "..." : groupLabel;
			let dndGroupDivHeight: number = divHeight > 200 ? 200 : divHeight; // random number

			let dndHandle: HTMLElement = this.UiModder.domConstruct.create("div", {
				"style": {
					"background-color": bgColor,
					"color": txtColor,
					"height": "20px",
					"cursor": "move"
				},
				"className": "dndHandle",
				"data-dndHeight": dndGroupDivHeight,
				"data-dndId": groupObj.group.ID,
				"data-dndMonth": this.id,
				"data-dndType": "group",
				"draggable": true
			}, node);

			on(dndHandle, "dragstart", function (evt) { // scope: dndHandle
				this.style.height = this.dataset.dndheight + "px";
				evt.dataTransfer.setData('text/plain', JSON.stringify({ dndId: this.dataset.dndid, dndMonth: this.dataset.dndmonth, dndType: this.dataset.dndtype }));
			});
			on(dndHandle, "dragend", function (evt) { // scope: this.dndNode
				this.style.height = "20px";
			});

			let groupLabelNodeContaner: HTMLElement = this.UiModder.domConstruct.create("div", {
				style: "padding-top: " + divHeight / 2 + "px; padding-bottom: 5px; overflow:hidden",
			}, node);

			let groupLabelNode: HTMLElement = this.UiModder.domConstruct.create("div", {
				//style: "margin-top: " + divHeight / 2 + "px;",
				"className": "groupLabelText",
				innerHTML: groupLabel
			});

			this.UiModder.domConstruct.place(groupLabelNode, groupLabelNodeContaner);

			on(node, "click", lang.hitch(this, "_onclick_groupDiv"));

			this.UiModder.domConstruct.place(node, startDayWidget.groupNode);

		} else {
			console.warn("node is not present");
		}

	}

	_onclick_groupDiv(evt: Event, groupId?: string): void {

		let clickedGroupObj: _groupRegistryObj = null;
		let groupIndex: number = -1;

		if (typeof groupId == "undefined" || groupId == null) {
			if (evt && evt.target && this.UiModder.domAttr.has(<HTMLElement>evt.target, "data-group")) {
				groupId = this.UiModder.domAttr.get(<HTMLElement>evt.target, "data-group");

				// emit ONLY if the call is from a dom event. otherwise stackoverflow
				this.emit("MonthColumn/groupDivClick", groupId);
			}
		}

		if (groupId) {

			groupIndex = -1;

			for (let i = 0; i < this._groupRegistry.length; i++) { // muss hier machen wegen dem groupIndex
				let groupObj = this._groupRegistry[i];
				if (groupObj.group.ID == groupId) {
					groupIndex = i;
					clickedGroupObj = groupObj;
					break;
				}
			}



			// wen es die Gruppe im Monat gibt
			if (groupIndex >= 0) {

				// highlight appointments
				for (let groupDay of clickedGroupObj.days) {
					groupDay._highlightGroupAppointments(groupId);
				}

				// refresh all days but not the modified one, becaus it is in the edit process, and highliight all grou appointments
				for (let dayRow of this._dayRegistry) {
					let skipThisDay: boolean = false;
					for (let appointmentObj of dayRow._appointments) {
						if (appointmentObj.GroupId == groupId) skipThisDay = true;
					}
					if (skipThisDay === false) dayRow.refreshDisplayValue();
				}

				// angeklicktes groupDiv rausnehmen, restlichen anzeigen, und dann das angeklickte am lastRail anzeigen
				this._groupRegistry.splice(groupIndex, 1)[0];

				// _groupRegistry sortieren, um vorherige ver�nderungen r�ckg�gngig zu machen
				this._groupRegistry.sort(function (a, b) {
					let fa: string = a.group.date_start.substring(6, 10) + "-" + a.group.date_start.substring(3, 5) + "-" + a.group.date_start.substring(0, 2);
					let fb: string = b.group.date_start.substring(6, 10) + "-" + b.group.date_start.substring(3, 5) + "-" + b.group.date_start.substring(0, 2);

					if (fa < fb) {
						return -1;
					}
					if (fa > fb) {
						return 1;
					}
					return 0;
				});

				this.displayedConcurrentGroups_limit--; // den limit VOR�BERGEHEND �ndern, damit Gruppen sich nicht �berlagern
				this._displayGroups(); // alle �brigen groupDivs ohne des angeklickten anzeigen
				this.displayedConcurrentGroups_limit++; // den limit zur�ck �ndern

				this._groupRegistry.push(clickedGroupObj); // den zuvor entfernte group wieder in die Monatsregistry eintragen, an letzter Stelle ((...) weil clickedGroupObj eni einem Array ist)

				this._displayGroupOnLastRail(clickedGroupObj); // die anageklickte group auf der letzten Bahn anzeigen
			} else {
				this._displayGroups(); // default display
			}
		}
	}

	// groupNode width an die Anzahl der groups anpassen
	_setGroupNodeWidth_forMonth(monthItem: MonthColumn, width: number): void {
		for (let day of monthItem._dayRegistry) {
			day._setGroupNodeWidth(width);
		}
	}

	// find a rail, that is free on all days of the given month, on which the group is active
	findFreeRail(groupRegistryObj: _groupRegistryObj, maxRailsCount: number): number { // groupRegistryObj {group:group, days: days[]} , maxRailsCount: int 

		let sMonthDate: string = locale.format(this.monthDate, {
			selector: "date",
			datePattern: "yyyy-MM"
		});

		let daysToShow: Array<MdsLax<InstanceType<typeof DayRow>>> = [];
		let freeRailIndex: number = 0;
		let rail_free: boolean = false;

		// we get all days which are in this month
		for (let groupDay of groupRegistryObj.days) {
			let sDay_monthDate = locale.format(groupDay.date, {
				selector: "date",
				datePattern: "yyyy-MM"
			});

			if (sDay_monthDate == sMonthDate) { daysToShow.push(groupDay); }
		}

		// sort em
		daysToShow.sort(function (a, b): number {

			let fa: string = locale.format(a.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});
			let fb: string = locale.format(b.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			if (fa < fb) {
				return -1;
			}
			if (fa > fb) {
				return 1;
			}
			return 0;

		});

		// now we work with daysToShow[]

		for (let i = 0; i < maxRailsCount; i++) {
			if (rail_free == false) {
				if (typeof daysToShow[0]._rails[i] == "undefined") {
					if (this._checkRail_isFree(i, daysToShow) == true) {
						freeRailIndex = i;
						rail_free = true;
					}
				}
			}
		}

		if (rail_free == false) {
			//console.log("no free rail for start on day ", groupDay, ", max index is ", maxRailsCount);
		}

		if (rail_free == true) {
			this._setRails(groupRegistryObj, freeRailIndex);
			return freeRailIndex;
		} else {
			//console.log("RESULT: no free rail for ", groupRegistryObj, ", on ", sMonthDate);
			return null;
		}
	}

	// clear rails, which the given group has occupied (for instance lets undefined "holes" in the array due to delete. It's wanted)
	_clearRails_forGroup(groupRegistryObj: _groupRegistryObj, monthItem: MonthColumn, railIndex: number): void {

		for (let groupDay of groupRegistryObj.days) {
			let strGroupDay_date: string = locale.format(groupDay.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			for (let monthDay of monthItem._dayRegistry) {
				let strMonthDay_date: string = locale.format(monthDay.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});

				if (strGroupDay_date == strMonthDay_date) {
					if (monthDay._rails[railIndex]) {
						delete monthDay._rails[railIndex]; // hinterl�sst undefined element im Array. Und das ist gut so. Hoffe ich..
						console.info("DELETED RAIL ", railIndex, " am Tag ", strMonthDay_date);
					}
				}
			}
		}

	}

	_clearAllRails(): void {
		for (let monthDay of this._dayRegistry) {
			monthDay._rails = [];
		}
	}

	// ob die Bahn f�r die dauer der Tage frei ist.
	_checkRail_isFree(railIndex: number, days: Array<MdsLax<InstanceType<typeof DayRow>>>): boolean {

		let rail_isFree: boolean = true;

		for (let j = 0; j < days.length; j++) {

			let rails: {} = days[j]._rails;

			if (typeof rails[railIndex] != "undefined") {
				rail_isFree = false;
			}
		}

		return rail_isFree;
	}

	// "occupies" the given rail for the duration of the group only in the GIVEN MONTH(if the rail is free/undefined)
	_setRails(groupRegistryObj: _groupRegistryObj, railIndex: number): void {

		let strMonthDate: string = locale.format(this.monthDate, {
			selector: "date",
			datePattern: "yyyy-MM"
		});

		let groupDaysOfTheMonth: Array<MdsLax<InstanceType<typeof DayRow>>> = []; // nur die Tage, die sich innerhalb von Monat befinden

		for (let groupDay of groupRegistryObj.days) {

			let strGroupDay_MonthDate: string = locale.format(groupDay.date, {
				selector: "date",
				datePattern: "yyyy-MM"
			});

			if (strGroupDay_MonthDate == strMonthDate) {
				groupDaysOfTheMonth.push(groupDay);
			}
		}


		groupDaysOfTheMonth.sort(function (a, b) {
			let fa: string = locale.format(a.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});
			let fb: string = locale.format(b.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			if (fa < fb) {
				return -1;
			}
			if (fa > fb) {
				return 1;
			}
			return 0;
		});

		if (this._checkRail_isFree(railIndex, groupDaysOfTheMonth) == true) {

			// check if the object not registered already in another rail (for some wierd reason)
			let groupExists: boolean = false;

			for (let k = 0; k < groupDaysOfTheMonth[0]._rails.length; k++) {
				if (groupDaysOfTheMonth[0]._rails[k]) {
					if (groupDaysOfTheMonth[0]._rails[k]["ID"] == groupRegistryObj.group.ID) {
						groupExists = true
					}
				}
			}

			if (groupExists == false) {
				for (let groupDay of groupDaysOfTheMonth) {
					groupDay._rails[railIndex] = groupRegistryObj.group;
				}
			}

		} else {
			console.warn("_setRails FAIL - No free rail found for ", groupRegistryObj.group, ", on ", this.monthDate);
		}

	}

	// have monthItem.daysWorkload[] filled. darauf basiert der maxRailindex und die Breite des groupNodes;
	_evaluateConcurrenGroups(): void {

		this.daysWorkload = [];

		for (let monthDay of this._dayRegistry) {

			let strMonthDayDate: string = locale.format(monthDay.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			for (let groupObj of this._groupRegistry) {
				let strGroupDateStart: string = groupObj.group.date_start.substring(6, 10) + "-" + groupObj.group.date_start.substring(3, 5) + "-" + groupObj.group.date_start.substring(0, 2);
				let strGroupDateEnd: string = groupObj.group.date_end.substring(6, 10) + "-" + groupObj.group.date_end.substring(3, 5) + "-" + groupObj.group.date_end.substring(0, 2);

				if (strGroupDateStart <= strMonthDayDate && strGroupDateEnd >= strMonthDayDate) {
					// group is aktiv on this day, 
					let dayExists: boolean = false;

					if (this.daysWorkload.length > 0) {

						for (let workloadObj of this.daysWorkload) { // workloadObj: {day:day, concurrentGroups: Array<group>}

							let workloadObj_dayDate;

							if (typeof workloadObj.day.date == "string" && /^\d{4}-\d{2}-\d{2}$/.test(workloadObj.day.date)) {
								workloadObj_dayDate = workloadObj.day.date;
							} else {
								workloadObj_dayDate = locale.format(workloadObj.day.date, {
									selector: "date",
									datePattern: "yyyy-MM-dd"
								});
							}

							if (workloadObj_dayDate == strMonthDayDate) {
								let dayExists = true;

								let groupExists = false;

								for (let workloadGroup of workloadObj.concurrentGroups) {
									if (workloadGroup.ID == groupObj.group.ID) groupExists = true;
								}

								if (groupExists == false) {
									workloadObj.concurrentGroups.push(groupObj.group)
								}
							}
						}
					}

					if (dayExists == false) {
						this.daysWorkload.push({ day: monthDay, concurrentGroups: [] });
						this.daysWorkload[this.daysWorkload.length - 1].concurrentGroups.push(groupObj.group);
					}

				}// end if
			}
		} //end for(monthDay of monthItem._dayRegistry)

		// groupNode width ---------------------------- start
		let concurrentGroupsQuantity: number = 1;

		if (this.daysWorkload.length) {
			for (let x = 0; x < this.daysWorkload.length; x++) {
				if (this.daysWorkload[x].concurrentGroups.length > concurrentGroupsQuantity) {
					concurrentGroupsQuantity = this.daysWorkload[x].concurrentGroups.length;
				}
			}
		}

		// groupNode width an die Anzahl der groups anpassen
		// wenn die ankzahl der parrallelen gruppen kleiner ist als der Limit, ist die breite des divs dynamisch, sonst auf das limit begrenzt
		let desiredGroupNodeWidth: number
		let offset_pfusch = 3.5; // joah... gute frage...
		if (concurrentGroupsQuantity < 7){
			offset_pfusch = 2;
		}
		if (concurrentGroupsQuantity < 5){
			offset_pfusch = 1;
		}
		if (concurrentGroupsQuantity < this.displayedConcurrentGroups_limit) {
			desiredGroupNodeWidth = this.groupDivWidth * (concurrentGroupsQuantity+offset_pfusch);
		} else {
			desiredGroupNodeWidth = this.groupDivWidth * (this.displayedConcurrentGroups_limit+offset_pfusch);
		}

		this._setGroupNodeWidth_forMonth(this, desiredGroupNodeWidth);
		// groupNode width ---------------------------- end

	}

	/// display groups (DOM ) --------------------------------------------------------------------------------END

	_handleVisibleColumns(data: { event_d: boolean, text_d: boolean, groupNodeWidth: number }): void {

		if (this.domNode) {
			if (data.event_d === true && data.text_d === true) {
				//this.UiModder.domStyle.set(this.domNode, "width", "600px");
			} else {
				//this.UiModder.domStyle.set(this.domNode, "width", "350px");
			}
		}

		for (let dayRow of this._dayRegistry) {
			dayRow._adjustVisibleColumns(data);
		}

		if (this._dayRegistry.length && this._dayRegistry[0].valueNode) {

			if (this._fetchGroupDataTimeout != null) clearTimeout(this._fetchGroupDataTimeout);
			this._fetchGroupDataTimeout = setTimeout(lang.hitch(this, function () {
				this.fetchGroupData(this._dayRegistry);
			}), 500);
		}

	}

	setEditable(value: boolean): void {
		this.editable = value;

		let days: Array<MdsLax<InstanceType<typeof DayRow>>> = this.getAllDays();
		for (let i = 0; i < days.length; i++) {
			let day = days[i];

			day.editable = value;
		}
	}

	_setEditableAttr(value: boolean): void {
		this.setEditable(value)
	}

	getMonthLabel(): string {
		if (this.monthDate != null) {
			let label: string = locale.format(this.monthDate, {
				selector: "date",
				datePattern: "MMMM" + (this.includeYearInTitle ? " yyyy" : "")
			});

			return label;
		}
		return "month/year error";
	}
	getDayBefore(dayRow: MdsLax<InstanceType<typeof DayRow>>): MdsLax<InstanceType<typeof DayRow>> {
		let dayBefore: MdsLax<InstanceType<typeof DayRow>>;
		for (let i = 0; i < this._dayRegistry.length; i++) {
			let currentDayRow: MdsLax<InstanceType<typeof DayRow>> = this._dayRegistry[i];

			if (currentDayRow == dayRow) {
				return dayBefore;
			}

			dayBefore = currentDayRow;
		}

		return null;
	}
	getDayAfter(dayRow: MdsLax<InstanceType<typeof DayRow>>): MdsLax<InstanceType<typeof DayRow>> {
		let dayBefore: MdsLax<InstanceType<typeof DayRow>>;
		for (let i = 0; i < this._dayRegistry.length; i++) {
			let currentDayRow: MdsLax<InstanceType<typeof DayRow>> = this._dayRegistry[i];

			if (dayRow == dayBefore) {
				return currentDayRow;
			}

			dayBefore = currentDayRow;
		}

		return null;
	}

	_onDayRow_directValueChanged(message: { modifiedAppointment: MCP_currentlyModifiedAppointment, sender: MdsLax<InstanceType<typeof DayRow>> }): void {

		// Wenn die gruppe �ber ID verf�gt -> primaryColor und description setzen. Sonst wird das in DB mit null �berschrieben! (dayRow kennt die properties nicht)
		// !!! anderung byref hier!!!

		if (message.modifiedAppointment.group && message.modifiedAppointment.group.ID) {
			for (let groupRegObj of this._groupRegistry) {
				if (groupRegObj.group.ID == message.modifiedAppointment.group.ID) {
					if (groupRegObj.group.primaryColor) message.modifiedAppointment.group.primaryColor = groupRegObj.group.primaryColor;
					if (groupRegObj.group.label) message.modifiedAppointment.group.description = groupRegObj.group.label;
					if (groupRegObj.group.tooltip) message.modifiedAppointment.group.tooltip = groupRegObj.group.tooltip;
					if (groupRegObj.group.secondaryColor) message.modifiedAppointment.group.secondaryColor = groupRegObj.group.secondaryColor;
				}
			}
		}

		this.emit("DayRow/directValueChanged", message);
	}

	_addListenersToDay(day: MdsLax<InstanceType<typeof DayRow>>): void {
		day.on("DayRow/dblClick", lang.hitch(this, function (message: { date: Date, appointment: MCP_appointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
			this.emit("DayRow/dblClick", message);
		}));
		day.on("DayRow/directValueChanged", lang.hitch(this, "_onDayRow_directValueChanged"));
		day.on("saveButtonState", lang.hitch(this, function (message: { disabled: boolean }) {
			this.emit("saveButtonState", message);
		}));
		day.on("DayRow/dnd_drop", lang.hitch(this, function (message: { dndData: object, sender: MdsLax<InstanceType<typeof DayRow>> }) {
			this.emit("DayRow/dnd_drop", message);
		}));
		day.on("updateGroupOrder", lang.hitch(this, function (message: { dndData: object, sender: MdsLax<InstanceType<typeof DayRow>> }) {
			this.emit("updateGroupOrder", message);
		}));

		day.on("DayRow/appointmentClick", lang.hitch(this, function (appointment: MCP_appointment) {
			let groupId: string;
			if (appointment && appointment.GroupId) {
				groupId = appointment.GroupId;
			}
			this._onclick_groupDiv(null, groupId);
		}));
	}

	addDay(date: Date, addDublicate?:boolean): void {
		let existingDay: MdsLax<InstanceType<typeof DayRow>> = this.getDay(date);
		if (addDublicate != true){ //wenn undefined wird auf false gesetzt
			addDublicate = false;
		}
		if ((!existingDay) || addDublicate) {
			let day: MdsLax<InstanceType<typeof DayRow>> = new DayRow({
				date: date,
				editable: this.editable,
				print: this.print,
				monthColumn: this
			});

			day._monthID = this.id; // f�r dnd

			this._addListenersToDay(day);
			day.on("addDateRow", lang.hitch(this, this.addDuplicateDay)); 
			
			/*
			fuegt ein container ein, damit wir zusaetzliche termine am gleichen tag hinzufuegen koennen
			<div container>
				<day element>
				<day element 2>
				...
			</div>
			*/
			let contID = this.monthDate.getFullYear() + "-" + this.monthDate.getMonth();
			contID += "-" + ((day.getDayLabel().replace(" ", "-")).replace(".","-"));
			contID = "container-" + contID;
			if (this.dayRowsContainer.getElementsByClassName(contID).length === 0){
				let divCont = document.createElement("div");
				divCont.classList.add(contID);
				this.dayRowsContainer.appendChild(divCont);
			}
			let targetContainer = this.dayRowsContainer.getElementsByClassName(contID)[0];
			day.placeAt(targetContainer);
			//day.placeAt(this.dayRowsContainer);

			if (this._dayRegistry.length % 2) {
				this.UiModder.domClass.add(day.domNode, "pong");
			} else {
				this.UiModder.domClass.add(day.domNode, "ping");
			}

			this._dayRegistry.push(day);

			// neuen Tag ver�ffentlichen
			//
		}
	}

	addDuplicateDay(day: Date){
		this.addDay(day, true);
	}

	getDay(date: Date): MdsLax<InstanceType<typeof DayRow>> {
		for (let i = 0; i < this._dayRegistry.length; i++) {
			let dayItem: MdsLax<InstanceType<typeof DayRow>> = this._dayRegistry[i];

			if (dayItem.date == date) {
				return dayItem;
			}
		}

		return null;
	}

	getAllDays(): Array<MdsLax<InstanceType<typeof DayRow>>> {
		return this._dayRegistry;
	}


	removeAllDays(): void {

		if (this._dayRegistry && this._dayRegistry.length) {
			for (let i = 0; i < this._dayRegistry.length; i++) {
				this._dayRegistry[i].destroy();
			}
			this._dayRegistry = [];
		}

		if (this.dayRowsContainer) this.UiModder.domAttr.set(this.dayRowsContainer, "innerHTML", null);
	}

	_setMonthDate(year: number, month: number): void {

		this._groupRegistry = [];
		this._appointmentRegistry = [];

		this.year = year;
		this.month = month;
		this.monthDate = new Date(this.year, this.month);

		if (this.MonthNameDisplay) this.UiModder.domAttr.set(this.MonthNameDisplay, "innerHTML", this.getMonthLabel());

		this.removeAllDays();

		let daysOfMonth: number = dojoDate.getDaysInMonth(this.monthDate);
		for (let i = 0; i < daysOfMonth; i++) {
			let dayDate = dojoDate.add(this.monthDate, "day", i);
			this.addDay(dayDate);
		}

		this._setMonthSelectionDate();

		if (this._fetchGroupDataTimeout != null) clearTimeout(this._fetchGroupDataTimeout);
		this._fetchGroupDataTimeout = setTimeout(lang.hitch(this, function () {
			this.fetchGroupData(this._dayRegistry);
		}), 800);

		if (this._fetchDraftDataTimeout != null) clearTimeout(this._fetchDraftDataTimeout);
		this._fetchDraftDataTimeout = setTimeout(lang.hitch(this, function () {
			this.fetchMultipleDayRowData(this._dayRegistry, "draft");
		}), 800);

		//emit damit immer termine nach filter angezeit werden, auch wenn der monat gewechselt wurde
		this.emit("refreshStaticValues");
	}

	// fetch data ----------------------------------------------- start

	// ----------------------- handle group data ----------------------------- END



	fetchGroupData(dayRows: Array<MdsLax<InstanceType<typeof DayRow>>>): void {


		this.StandbyStart(this.domNode);
		if (this._fetchGroupDataRequest != null) {
			this._fetchGroupDataRequest.cancel();
		}

		this._groupRegistry = [];

		if (dayRows.length) {
			dayRows.sort(function (a, b) {
				let fa: string = locale.format(a.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});
				let fb: string = locale.format(b.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});

				if (fa < fb) {
					return -1;
				}
				if (fa > fb) {
					return 1;
				}
				return 0;
			});
			let sDateStart: string = locale.format(dayRows[0].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});
			let sDateEnd: string = locale.format(dayRows[dayRows.length - 1].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			let DayRowDates: { dateStart: string, dateEnd: string } = { dateStart: sDateStart, dateEnd: sDateEnd };

			let groupApiUrl = window.appRoot + "MonthColumnPlan/FetchGroupData";
			if (this.flagMinimalModeWasActivatedOnce == false){
				this._fetchGroupDataRequest = this.RequestManager.post(
					groupApiUrl,
					{
						jsonData: JSON.stringify(DayRowDates)
					},
					lang.hitch(this, this._onFetchGroupData_response, dayRows),
					lang.hitch(this, function (err) {
						console.error("ERROR: ", err);
					}),
					false // sync
				);
			}else{
				this._fetchGroupDataRequest = [];
				this._onFetchGroupData_response([], []);
			}

		}

	}

	_onFetchGroupData_response(dayRows: Array<MdsLax<InstanceType<typeof DayRow>>>, response: Array<MCP_group>): void {

		this.StandbyStop();

		let groupItems = response;

		if (groupItems.length) {

			for (let i = 0; i < groupItems.length; i++) {

				let groupItem: MCP_group = groupItems[i];

				let groupExists: boolean = false;

				if (this._groupRegistry.length > 0) {

					for (let registryObj of this._groupRegistry) {

						if (registryObj.group.ID == groupItem.ID) {

							registryObj.group = groupItem;
							groupExists = true;
						}
					}

				}

				if (groupExists == false) {

					// appointments werden sp�ter erg�nzt
					let groupRegistryObj = { group: groupItem, days: [], appointments: [] };

					if (groupItem.date_start && groupItem.date_end) {
						let strGroupDateStart: string = (groupItem.date_start.substring(6, 10) + "-" + groupItem.date_start.substring(3, 5) + "-" + groupItem.date_start.substring(0, 2));
						let strGroupDateEnd: string = (groupItem.date_end.substring(6, 10) + "-" + groupItem.date_end.substring(3, 5) + "-" + groupItem.date_end.substring(0, 2));

						for (let x = 0; x < dayRows.length; x++) {
							let dayRow: MdsLax<InstanceType<typeof DayRow>> = dayRows[x];

							let strRowDate: string = locale.format(dayRow.date, {
								selector: "date",
								datePattern: "yyyy-MM-dd"
							});

							if (strRowDate >= strGroupDateStart && strRowDate <= strGroupDateEnd) {

								groupRegistryObj.days.push(dayRow);
							}
						}

					} else {
						console.warn("no start or end date for group", groupItem.ID)
					}

					this._groupRegistry.push(groupRegistryObj);

				}

			}// end for groupItems

		} else {  // end if (groupItems.length)

			console.warn("No Group Data");
		}

		this._groupRegistry.sort(function (a, b) {

			let fa: string = a.group.date_start.substring(6, 10) + "-" + a.group.date_start.substring(3, 5) + "-" + a.group.date_start.substring(0, 2);
			let fb: string = b.group.date_start.substring(6, 10) + "-" + b.group.date_start.substring(3, 5) + "-" + b.group.date_start.substring(0, 2);

			if (fa < fb) {
				return -1;
			}
			if (fa > fb) {
				return 1;
			}
			return 0;
		});

		this._assignAppointmentsToGroup();

		if (this._dayRegistry.length && this._dayRegistry[0].valueNode) {
			this._displayGroups(); // for correct absolute positioning of div's the DOM must be drawn first
		}
	}

	// ----------------------- handle group data ----------------------------- END

	// -------------------- handle appointment data ---------------------------- START
	public currentFilterPanelSettings:any;
	_getBookingsList(currentFilterSettings: string): void {

		if (this._fetchBookingsRequest != null) {
			this._fetchBookingsRequest.cancel();
		}

		this.StandbyStart(this.domNode);

		let fa: string, fb: string;

		if (this._dayRegistry.length) {
			this._dayRegistry.sort(function (a, b) {
				fa = locale.format(a.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});
				fb = locale.format(b.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});

				if (fa < fb) {
					return -1;
				}
				if (fa > fb) {
					return 1;
				}
				return 0;
			});
			let sDateStart: string = locale.format(this._dayRegistry[0].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});
			let sDateEnd: string = locale.format(this._dayRegistry[this._dayRegistry.length - 1].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			let filterPanelStatus = this.currentFilterPanelSettings;
			if ((typeof filterPanelStatus == 'undefined') || (filterPanelStatus == null)){
				filterPanelStatus = [{ _sectionName: "searchParameter"}];
			}
			let jsonData: { dateStart: string, dateEnd: string, filterSettings?: any } = { dateStart: sDateStart, dateEnd: sDateEnd, filterSettings: { sections: filterPanelStatus } };

			if (this.flagMinimalModeWasActivatedOnce == false){
				let url = window.appRoot + "MonthColumnPlan/GetBookingsList";
	
				this._fetchBookingsRequest = this.RequestManager.post(
					url,
					{
						jsonData: JSON.stringify(jsonData)
					},
					lang.hitch(this, "_onGetBookingsListResponse"),
					lang.hitch(this, function (err) {
						console.error("ERROR: ", err);
					}),
					false // sync
				);
			}else{
				this._fetchBookingsRequest = { appointments :[]};
				this._onGetBookingsListResponse({ appointments: [] });
			}

		}
	}

	_onGetBookingsListResponse(response): void {

		this.StandbyStop();
		if (Object.keys(response).length == 0){
			//is empty
			let hotfix = {
				appointments: []
			};
			this._onGetBookingsListResponse(hotfix);
			return;
		}
		if (Array.isArray(response.appointments) && response.appointments.length === 0) {
			this._staticData = [];
			for (let day of this.getAllDays()) {
				day.clearStaticData();
			}
			return;
		}

		if (response && response.appointments && response.appointments.length) {
			this._staticData = response.appointments;
		} else {

		}

		//emits static alternative farben fuer das dropdown
		if (typeof this._staticData != 'undefined'){
			if (this._staticData != null){
				for (let dat of this._staticData) {
					if (typeof dat.alternativeColorations != 'undefined') {
						if (dat.alternativeColorations.length > 0) {
							for (let altCol of dat.alternativeColorations) {
								this.emit("MonthColumn/registerAlternativeColorNameBooking", altCol.colorationName);
							}
						}
					}
				}
			}
		}

		let strBookingDateEnd: string;
		let strBookingDateStart: string;
		let strDayRowDate: string;

		let is_dayBusy: boolean;

		for (let x = 0; x < this._dayRegistry.length; x++) {
			let dayRow: MdsLax<InstanceType<typeof DayRow>> = this._dayRegistry[x];

			is_dayBusy = false;

			strDayRowDate = locale.format(dayRow.date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});

			if (typeof this._staticData != 'undefined'){
				if (this._staticData != null){
					for (let booking of this._staticData) {

						strBookingDateStart = booking.dateStart.slice(0, 10);

						strBookingDateEnd = booking.dateEnd.slice(0, 10);

						if (strDayRowDate >= strBookingDateStart && strDayRowDate <= strBookingDateEnd) {

							this._assignDayRowDataToWidget(dayRow, booking);
							is_dayBusy = true;
						}
					}
				}
			}

			if (is_dayBusy == false) {
				dayRow.clearStaticData();
			}
		}

		this._displayGroups();
	}

	fetchMultipleDayRowData(dayRows, sType): void {

		if (this._fetchDraftDataRequest != null) {
			this._fetchDraftDataRequest.cancel();
		}

		this.StandbyStart(this.domNode);

		if (sType == "darft") {
			for (let monthDay of dayRows) {
				monthDay._appointments = []; // damit die appointments ohne ID (welche jetzt eine ID haben) nicht doppelt vorkommen
				monthDay.refreshDisplayValue();
				for (let i = 0; i < this._appointmentRegistry.length; i++) {
					if (this._appointmentRegistry[i].day == monthDay) {
						this._appointmentRegistry.splice(i, 1);

					}
				}
			}
		}

		if (dayRows.length) {
			dayRows.sort(function (a, b) {
				let fa: string = locale.format(a.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});
				let fb: string = locale.format(b.date, {
					selector: "date",
					datePattern: "yyyy-MM-dd"
				});

				if (fa < fb) {
					return -1;
				}
				if (fa > fb) {
					return 1;
				}
				return 0;
			});
			let sDateStart: string = locale.format(dayRows[0].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});
			let sDateEnd: string = locale.format(dayRows[dayRows.length - 1].date, {
				selector: "date",
				datePattern: "yyyy-MM-dd"
			});


			let DayRowDates: { dateStart: string, dateEnd: string, type: string } = { dateStart: sDateStart, dateEnd: sDateEnd, type: sType };

			let url = window.appRoot + "MonthColumnPlan/FetchMultipleDayRowData";
			if (this.flagMinimalModeWasActivatedOnce == false){
				this._fetchDraftDataRequest = this.RequestManager.post(
					url,
					{
						jsonData: JSON.stringify(DayRowDates)
					},
					lang.hitch(this, "_onFetchMultipleDayRowData_response", dayRows),
					lang.hitch(this, function (err) {
						if (err["Message"] && err["Message"] == "success") {
							this._onFetchMultipleDayRowData_response(err);
							return;
						}
						console.error("ERROR: ", err);
					}),
					false // sync
				);
			}else{
				this._fetchDraftDataRequest = { appointments:[]};
				this._onFetchMultipleDayRowData_response(dayRows, { appointments: [] });
			}

		}

	}


	_onFetchMultipleDayRowData_response(dayRows: Array<MdsLax<InstanceType<typeof DayRow>>>, response: any): void {

		let dayRowResultItems: Array<MCP_appointment> = response.appointments;
		// daten an die DayWidgets schicken
		// appointments mit leeren text werden geloscht, da diese nicht korrekt angezeigt werden
		let newList :Array<MCP_appointment> = [];
		for (let res of dayRowResultItems){
			if ((res.Description == "") || (res.Description == null) || (typeof res.Description == 'undefined')){
				//workaround
				// appointments mit leeren text werden geloescht
				let newRes: MCP_currentlyModifiedAppointment = {
					ID: res.ID,
					text: res.Description,
					date: res.Date,
					primaryColor: res.TextColor,
					secondaryColor: res.BackColor,
					group: {
						ID: res.GroupId,
						description: null,
						primaryColor: null,
						secondaryColor: null,
						tooltip: null,
					}
				};
				this.emit("deleteApointment", newRes);
			}else{
				newList.push(res); // alle, nicht leeren, appointments werden normal angezeigt
			}
		}
		dayRowResultItems = newList; // leere Elemente wurden rausgefiltered

		
		if (dayRowResultItems.length) {
			for (let i = 0; i < dayRowResultItems.length; i++) {
				let dayRowResultItem = dayRowResultItems[i];

				for (let x = 0; x < dayRows.length; x++) {
					let dayRow = dayRows[x];

					let strDate = locale.format(dayRow.date, {
						selector: "date",
						datePattern: "yyyy-MM-dd"
					});

					if (strDate == dayRowResultItem["Date"]) {
						this._assignDayRowDataToWidget(dayRow, dayRowResultItem);
					}
				}
			}
		}

		this._assignAppointmentsToGroup();

		this.StandbyStop();

	}

	_assignDayRowDataToWidget(dayRowWidget: MdsLax<InstanceType<typeof DayRow>>, dayRowData: MCP_appointment | MCP_booking): void {

		if (dayRowData.Type == "static") {

			dayRowWidget._assignStaticValue(dayRowData);

		} else if (dayRowData.Type == "draft") {

			let appointmentRegistryObj = { appointment: <MCP_appointment>dayRowData, day: dayRowWidget };

			let index = -1;
			if (this._appointmentRegistry.length) {
				for (let i = 0; i < this._appointmentRegistry.length; i++) {
					if (this._appointmentRegistry[i].appointment.ID == dayRowData.ID) {
						index = i;
					}
				}
			}
			if (index == -1) {
				this._appointmentRegistry.push(appointmentRegistryObj);
			} else {
				this._appointmentRegistry[index] = appointmentRegistryObj;
			}


			dayRowWidget.processData(dayRowData);

		}
	}

	_assignAppointmentsToGroup(): void {

		if (this._appointmentRegistry.length && this._groupRegistry.length) {

			for (let groupRegistryObj of this._groupRegistry) { //groupRegistryObj: {group: groupItem, days: [], appointments: []}; 

				for (let appointmentObj of this._appointmentRegistry) {
					if (appointmentObj.appointment.GroupId == groupRegistryObj.group.ID) {
						//checkt ob eine appointment color gesetzt wurde, wenn ja dann ueberschreiben wir die gruppen farbe nicht
						let overWriteWithGroupColorsPrim = false;
						let overWriteWithGroupColorsSec = false;

						if (typeof appointmentObj.appointment.BackColor == 'undefined'){
							appointmentObj.appointment.BackColor = null;
						}
						if (typeof appointmentObj.appointment.TextColor == 'undefined'){
							appointmentObj.appointment.TextColor = null;
						}

						if (appointmentObj.appointment.BackColor == null){ //wenn keine farbe angegeben worden ist, wollen wir einfach die gruppenfarbe verwenden
							overWriteWithGroupColorsPrim = true;
						}
						if (appointmentObj.appointment.TextColor == null){
							overWriteWithGroupColorsSec = true;
						}

						if (typeof appointmentObj.appointment.BackColor == 'string'){ //null.indexOf funktioniert nicht so gut
							if (appointmentObj.appointment.BackColor.indexOf("~") != -1){ // wenn "~hex", dann wird explizit die gruppenfarbe verwendet
								overWriteWithGroupColorsPrim = true;
							}
						}
						if (typeof appointmentObj.appointment.TextColor == 'string'){
							if (appointmentObj.appointment.TextColor.indexOf("~") != -1){
								overWriteWithGroupColorsSec = true;
							}
						}

						appointmentObj.appointment["originalBackColor"] = appointmentObj.appointment.BackColor;
						appointmentObj.appointment["originalTextColor"] = appointmentObj.appointment.TextColor;
						if (overWriteWithGroupColorsPrim){
							appointmentObj.appointment.BackColor = groupRegistryObj.group.primaryColor;
						}
						if (overWriteWithGroupColorsSec){
							appointmentObj.appointment.TextColor = groupRegistryObj.group.secondaryColor;
						}

						appointmentObj.day.updateAppointments(appointmentObj.appointment);

						groupRegistryObj.appointments.push(appointmentObj);
					}
				}

			}

			this.refreshDayRows();
		}

		// have monthItem.daysWorkload[] filled. darauf basiert der maxRailindex und die Breite des groupNodes;
		this._evaluateConcurrenGroups();

		this._displayGroups();
	}

	refreshDayRows(): void {
		if (this._dayRegistry && this._dayRegistry.length) {
			for (let dayRow of this._dayRegistry) {
				dayRow.refreshDisplayValue();
			}
		}
	}

	_deleteAppointmentsFromRegistry(appointments: Array<MCP_appointment> | Array<string>): void { // appointment[] | ID[]
		let apptID: string;
		let dayRowToClear: MdsLax<InstanceType<typeof DayRow>>;
		let index: number = -1;
		let index2: number = -1;

		for (let appointment of appointments) {
			if (typeof appointment != "string") {
				apptID = appointment.ID;
			} else {
				apptID = appointment;
			}

			index = -1;


			for (let i = 0; i < this._appointmentRegistry.length; i++) {
				if (this._appointmentRegistry[i].appointment.ID == apptID) {
					index = i;
					dayRowToClear = this._appointmentRegistry[i].day;
				}
			}
			if (index != -1) {
				this._appointmentRegistry.splice(index, 1);

				index2 = -1;
				for (let z = 0; z < dayRowToClear._appointments.length; z++) {
					if (dayRowToClear._appointments[z].ID == apptID) {
						index2 = z;
					}
				}

				if (index2 > -1) {
					dayRowToClear._appointments.splice(index2, 1);
					dayRowToClear.refreshDisplayValue();
				}
			}
		}
	}

	// -------------------- handle appointment data ---------------------------- END

	// wird nur bein move appointment, move group und delete aufgerufen - keine verz�gerung hier
	_refreshDraftData(): void {

		// alles l�schen
		this._groupRegistry = [];
		this.daysWorkload = [];
		this._appointmentRegistry = [];
		for (let dayRow of this._dayRegistry) dayRow.clearDraftColumn();

		// alles laden
		this.fetchMultipleDayRowData(this._dayRegistry, "draft");
		this.fetchGroupData(this._dayRegistry);

	}

	// fetch data ----------------------------------------------- end

	flagMinimalModeWasActivatedOnce = false;
	flagMinimalModeShowEmptyDays = true;
	private _onHandle_ActivateMinimalMode(toggle:boolean){
		this.flagMinimalModeWasActivatedOnce = true;
		for (let day of this.getAllDays()){
			day.emit("useMinimalMode", toggle);
		}
		if (toggle){
			if (this.menuOptionsBar.classList.contains("w3-hide") == false) {
				this.menuOptionsBar.classList.add("w3-hide");
			}
		}else{
			if (this.menuOptionsBar.classList.contains("w3-hide") == true) {
				this.menuOptionsBar.classList.remove("w3-hide");
			}
		}
	}

	private _onHandle_MinimalModeToggleEmptyDays(t:boolean){
		this.flagMinimalModeShowEmptyDays = t;
		for (let day of this.getAllDays()){
			day.emit("minimalModeToggleShowEmptyDays", t);
		}
	}

	//----------------------- lifecycle -------------------------

	constructor(args) {
        super(...(arguments as unknown as []));
		this._dayRegistry = [];
		this._groupRegistry = [];
		this.daysWorkload = [];
		this._appointmentRegistry = [];
		this._staticData = null;
	}

	postMixInProperties(): void {
		super.postMixInProperties.apply(this, arguments as any);
	}

	postCreate(): void {
		super.postCreate.apply(this, arguments as any);

		this._setMonthDate(this.year, this.month);
		this.setupMonthSelectionDialog();
		this.on("useMinimalMode", lang.hitch(this, this._onHandle_ActivateMinimalMode));
		this.on("minimalModeToggleShowEmptyDays", lang.hitch(this, this._onHandle_MinimalModeToggleEmptyDays));
	}
	startup(): void {
		super.startup.apply(this, arguments as any);
	}
}

export default mdsWidget(MonthColumn);
